import { render, staticRenderFns } from "./UserAuthLayout.vue?vue&type=template&id=504cc966&scoped=true"
import script from "./UserAuthLayout.vue?vue&type=script&lang=js"
export * from "./UserAuthLayout.vue?vue&type=script&lang=js"
import style0 from "./UserAuthLayout.vue?vue&type=style&index=0&id=504cc966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504cc966",
  null
  
)

export default component.exports